export default {
  'backrest_movement_up': {
    cs: 'Backrest movement up',
    en: 'Backrest movement up',
    track: 'backrest_movement_up',
    opposite: 'backrest_movement_up_rev',
  },
  'backrest_movement_up2': {
    cs: 'Backrest movement up',
    en: 'Backrest movement up',
    track: 'backrest_movement_up2',
    opposite: 'backrest_movement_up_rev2',
  },
  'backrest_movement_up_rev': {
    cs: 'Backrest movement down',
    en: 'Backrest movement down',
    track: 'backrest_movement_up_rev',
    opposite: 'backrest_movement_up',
    required: 'backrest_movement_up',
    reset: true
  },
  'backrest_movement_up_rev2': {
    cs: 'Backrest movement down',
    en: 'Backrest movement down',
    track: 'backrest_movement_up_rev2',
    opposite: 'backrest_movement_up2',
  },
	'backrest_movement_down': {
    cs: 'Backrest movement down',
    en: 'Backrest movement down',
    track: 'backrest_movement_down',
    opposite: 'backrest_movement_down_rev',
  },
	'backrest_movement_down_rev': {
    cs: 'Backrest movement down',
    en: 'Backrest movement down',
    track: 'backrest_movement_down_rev',
    opposite: 'backrest_movement_down',
  },
  'foot_section_movement_up': {
    cs: 'Foot section movement',
    en: 'Foot section movement',
    track: 'foot_section_movement_up',
    opposite: 'foot_section_movement_down'
  },
  'foot_section_movement_down': {
    cs: 'Foot section movement',
    en: 'Foot section movement',
    track: 'foot_section_movement_down',
    opposite: 'foot_section_movement_up',
    blocking: [
      'foot_section_retraction',
      'foot_section_retraction2',
      'stainless_steel_tray',
			'stainless_steel_tray_only'
    ]
  },
	'foot_section_movement_down_from_trendelenburg': {
    cs: 'Foot section movement',
    en: 'Foot section movement',
    track: 'foot_section_movement_down_from_trendelenburg',
    opposite: 'foot_section_movement_down_from_trendelenburg_rev',
    blocking: []
  },
	'foot_section_movement_down_from_trendelenburg_rev': {
    cs: 'Foot section movement',
    en: 'Foot section movement',
    track: 'foot_section_movement_down_from_trendelenburg_rev',
    opposite: 'foot_section_movement_down_from_trendelenburg',
    blocking: []
  },
  'foot_section_retraction': {
    cs: 'Foot section retraction',
    en: 'Foot section retraction',
    track: 'foot_section_retraction',
    opposite: 'foot_section_retraction_rev',
    blocking: [
      'foot_section_movement_down',
      'foot_section_tilting',
      'vertical_leg_rest_tray_movement',
      'trendelenburg',
      'stainless_steel_tray',
			'stainless_steel_tray_only'
      
    ]
  },
  'foot_section_retraction2': {
    cs: 'Foot section retraction',
    en: 'Foot section retraction',
    track: 'foot_section_retraction2',
    opposite: 'foot_section_retraction2_rev',
    blocking: [
      'foot_section_tilting',
      'vertical_leg_rest_tray_movement',
      'trendelenburg'
    ],
    required: 'foot_section_movement_down'
  },
  'foot_section_retraction_rev': {
    cs: 'Foot section retraction',
    en: 'Foot section retraction',
    track: 'foot_section_retraction_rev',
    opposite: 'foot_section_retraction'
  },
  'foot_section_retraction2_rev': {
    cs: 'Foot section retraction',
    en: 'Foot section retraction',
    track: 'foot_section_retraction2_rev',
    opposite: 'foot_section_retraction2'
  },
  'foot_section_tilting': {
    cs: 'Foot section tilting',
    en: 'Foot section tilting',
    track: 'foot_section_tilting',
    opposite: 'foot_section_tilting_rev',
    blocking: [
      'foot_section_retraction',
      'foot_section_retraction2',
      'stainless_steel_tray',
			'stainless_steel_tray_only'
    ]
  },
  'foot_section_tilting_rev': {
    cs: 'Foot section tilting',
    en: 'Foot section tilting',
    track: 'foot_section_tilting_rev',
    opposite: 'foot_section_tilting'
  },
	'trendelenburg_foot_section_retraction_tilting': {
    cs: 'Foot section tilting',
    en: 'Foot section tilting',
    track: 'trendelenburg_foot_section_retraction_tilting',
    opposite: 'trendelenburg_foot_section_retraction_tilting_rev'
  },
	'trendelenburg_foot_section_retraction_tilting_rev': {
    cs: 'Foot section tilting',
    en: 'Foot section tilting',
    track: 'trendelenburg_foot_section_retraction_tilting_rev',
    opposite: 'trendelenburg_foot_section_retraction_tilting'
  },
  'horizontal_bed_movement_up': {
    cs: 'Horizontal bed movement up',
    en: 'Horizontal bed movement up',
    track: 'horizontal_bed_movement_up',
    opposite: 'horizontal_bed_movement_down',
    required: 'horizontal_bed_movement_down',
    reset: true
  },
  'horizontal_bed_movement_down': {
    cs: 'Horizontal bed movement down',
    en: 'Horizontal bed movement down',
    track: 'horizontal_bed_movement_down',
    opposite: 'horizontal_bed_movement_up',
    blocking: [
      'trendelenburg'
    ]
  },
  'horizontal_leg_rest_movement': {
    cs: 'Horizontal leg rest movement',
    en: 'Horizontal leg rest movement',
    track: 'horizontal_leg_rest_movement',
    opposite: 'horizontal_leg_rest_movement_rev'
  },
  'horizontal_leg_rest_movement_rev': {
    cs: 'Horizontal leg rest movement',
    en: 'Horizontal leg rest movement',
    track: 'horizontal_leg_rest_movement_rev',
    opposite: 'horizontal_leg_rest_movement'
  },
  'horizontal_leg_rest_tray_movement': {
    cs: 'Horizontal leg rest tray movement',
    en: 'Horizontal leg rest tray movement',
    track: 'horizontal_leg_rest_tray_movement',
    opposite: 'horizontal_leg_rest_tray_movement_rev'
  },
  'horizontal_leg_rest_tray_movement_rev': {
    cs: 'Horizontal leg rest tray movement',
    en: 'Horizontal leg rest tray movement',
    track: 'horizontal_leg_rest_tray_movement_rev',
    opposite: 'horizontal_leg_rest_tray_movement'
  },
  'horizontal_leg_rest_tray_tilting': {
    cs: 'Horizontal leg rest tray tilting',
    en: 'Horizontal leg rest tray tilting',
    track: 'horizontal_leg_rest_tray_tilting',
    opposite: 'horizontal_leg_rest_tray_tilting_rev'
  },
  'horizontal_leg_rest_tray_tilting_rev': {
    cs: 'Horizontal leg rest tray tilting',
    en: 'Horizontal leg rest tray tilting',
    track: 'horizontal_leg_rest_tray_tilting_rev',
    opposite: 'horizontal_leg_rest_tray_tilting'
  },
  'seat_section_adjustment': {
    cs: 'Seat section adjustment up',
    en: 'Seat section adjustment up',
    track: 'seat_section_adjustment',
    opposite: 'seat_section_adjustment_rev',
  },
  'seat_section_adjustment_rev': {
    cs: 'Seat section adjustment down',
    en: 'Seat section adjustment down',
    track: 'seat_section_adjustment_rev',
    opposite: 'seat_section_adjustment',
    required: 'seat_section_adjustment',
    reset: true
  },
  'trendelenburg': {
    cs: 'Trendelenburg',
    en: 'Trendelenburg',
    track: 'trendelenburg',
    opposite: 'trendelenburg_rev',
    blocking: [
      'foot_section_tilting',
      'foot_section_retraction',
      'foot_section_retraction2',
      'foot_section_movement_down',
      'horizontal_bed_movement_down'
    ]
  },
  'trendelenburg_rev': {
    cs: 'Trendelenburg',
    en: 'Trendelenburg',
    track: 'trendelenburg_rev',
    opposite: 'trendelenburg'
  },
  'trendelenburg_from_min': {
    cs: 'Trendelenburg',
    en: 'Trendelenburg',
    track: 'trendelenburg_from_min'
  },
  'trendelenburg_to_min': {
    cs: 'Trendelenburg',
    en: 'Trendelenburg',
    track: 'trendelenburg_to_min'
  },
  'vertical_leg_rest_movement': {
    cs: 'Vertical leg rest movement',
    en: 'Vertical leg rest movement',
    track: 'vertical_leg_rest_movement',
    opposite: 'vertical_leg_rest_movement_rev'
  },
  'vertical_leg_rest_movement_rev': {
    cs: 'Vertical leg rest movement',
    en: 'Vertical leg rest movement',
    track: 'vertical_leg_rest_movement_rev',
    opposite: 'vertical_leg_rest_movement'
  },
  'vertical_leg_rest_tray_movement': {
    cs: 'Vertical leg rest tray movement',
    en: 'Vertical leg rest tray movement',
    track: 'vertical_leg_rest_tray_movement',
    opposite: 'vertical_leg_rest_tray_movement_rev'
  },
  'vertical_leg_rest_tray_movement_rev': {
    cs: 'Vertical leg rest tray movement',
    en: 'Vertical leg rest tray movement',
    track: 'vertical_leg_rest_tray_movement_rev',
    opposite: 'vertical_leg_rest_tray_movement'
  },

  // controls additional
  'siderails_rotation': {
    cs: 'Siderails',
    en: 'Siderails',
    track: 'siderails_rotation',
    opposite: 'siderails_rotation_rev'
  },
  'siderails_rotation_rev': {
    cs: 'Siderails',
    en: 'Siderails',
    track: 'siderails_rotation_rev',
    opposite: 'siderails_rotation'
  },
  'stainless_steel_tray': {
    cs: 'Retractable steel tray',
    en: 'Retractable steel tray',
    track: 'stainless_steel_tray',
    opposite: 'stainless_steel_tray_rev',
		blocking: [
      'trendelenburg'
    ]
  },
  'stainless_steel_tray_rev': {
    cs: 'Retractable steel tray',
    en: 'Retractable steel tray',
    track: 'stainless_steel_tray_rev',
    opposite: 'stainless_steel_tray'
  },
  'stainless_steel_tray_only': {
    cs: 'Retractable steel tray',
    en: 'Retractable steel tray',
    track: 'stainless_steel_tray_only',
    opposite: 'stainless_steel_tray_only_rev',
		blocking: [
      'trendelenburg'
    ]
  },
  'stainless_steel_tray_only_rev': {
    cs: 'Retractable steel tray',
    en: 'Retractable steel tray',
    track: 'stainless_steel_tray_only_rev',
    opposite: 'stainless_steel_tray_only'
  }
}